import { gql } from "@apollo/client";

export const ADD_SUBMISSION_MUTATION = gql`
  mutation AddSubmission($input: SubmissionInput) {
    addSubmission(input: $input) {
      result
    }
  }
`;


export const GET_SUBMISSIONS = gql`
  query GetSubmissions($input: String) {
    submissions(input: $input) {
      data {
        id
        participantId
        displayName
        submissionDeadlineDate
        submissionReceivedDate
        submissionStatus
        description
      }
    }
  }
`;

export const DELETE_SUBMISSION = gql`
  mutation DeleteSubmission($input: SubmissionQuery) {
    deleteSubmission(input: $input) {
      result
    }
  }
`;

export const UPDATE_SUBMISSION = gql`
  mutation UpdateSubmission($input: SubmissionInput) {
    updateSubmission(input: $input) {
      result
    }
  }
`;


export const GET_SUBMISSION = gql`
  query GetSubmissionDetail($input: SubmissionQuery) {
    submission(input: $input) {
      id
      participantId
      submissionDeadlineDate
      submissionReceivedDate
      submissionStatus
      description
    }
  }
`;